@if (loading) {
  <div class="overlay" >
    <mat-spinner class="my-black-spinner"></mat-spinner>
  </div>
}
<mat-tab-group
  class="white-tabs"
  animationDuration="250ms"
  dynamicHeight
  >
  <!-- Tab 1: Home -->
  <mat-tab label="Phone List Report">
    <div class="tab-panel">
      <fieldset class="mat-like-fieldset">
        <legend class="mat-like-legend"><b>List Phone List Details</b></legend>

        <div class="white-box">
          <form [formGroup]="userInfoForm" autocomplete="off" novalidate>

            <!-- Row: Division + Section -->
            <div class="form-row">
              <!-- Division -->
              <mat-form-field appearance="outline" class="equal">
                <mat-label>Select Division</mat-label>
                <mat-select formControlName="divisionCtrl" (selectionChange)="onDivisionChange($event)">
                  @for (division of divisions; track division) {
                    <mat-option [value]="division.ID">
                      {{ division.Name }}
                    </mat-option>
                  }
                </mat-select>
              </mat-form-field>

              <!-- Section -->
              <mat-form-field appearance="outline" class="equal">
                <mat-label>Search Section</mat-label>
                <input
                  type="text"
                  matInput
                  (input)="searchSectionItem($any($event.target).value)"
                  [matAutocomplete]="autoSection"
                  formControlName="sectionCtrl"
                  aria-autocomplete="list"
                  />

                  <mat-autocomplete
                    #autoSection="matAutocomplete"
                    [displayWith]="displaySection"
                    (optionSelected)="onSectionSuggestionChanged($event)">
                    @for (i of sectiolist$ | async; track i) {
                      <mat-option [value]="i">
                        {{ i.Name }}
                      </mat-option>
                    }
                  </mat-autocomplete>
                </mat-form-field>
              </div>

              <!-- Buttons: always on the same line -->
              <div class="button-row">

                <button
                  mat-button
                  matTooltip="Reset"
                  id="btnCancel"
                  class="regular-button"
                  type="button"
                  (click)="clear()">
                  Reset
                </button>
              </div>

            </form>
          </div>

          <!-- Overlay spinner -->


          @if (fieldSelected) {
            <div class="visible-color-controls">
              <div class="actions-row">
                <button
                  mat-button
                  matTooltip=" Save Phone List Data"
                  id="btnSave"
                  class="regular-button"
                  type="button"
                  (click)="saveDivisionDetails()">
                  Save Phone List Data
                </button>
              </div>
              <mat-tab-group
                class="white-tabs"
                animationDuration="250ms"
                dynamicHeight
                >
                <mat-tab label="Divison/Section Data">
                  <fieldset> <legend>Divison Data</legend>
                  <div class="colorpicker-row">
                    <mat-checkbox
                      class="row-checkbox"
                      [(ngModel)]="divisionVisible"
                      [ngModelOptions]="{ standalone: true }">
                      Visible
                    </mat-checkbox>
                    Division Header Color :
                    <input
                      id="divisioncolorInput"
                      type="color"
                      class="color-input"
                      [(ngModel)]="selectedDivisonColor"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="onDivisionColorChanged($event)"
                      [disabled]="!divisionVisible"
                      aria-label="Pick division color" />
                      <span class="hex-display">{{ selectedDivisonColor }}</span>
                      <mat-form-field appearance="outline" class="text-field small-text-field">
                        <mat-label>Select/Enter Color</mat-label>
                        <input
                          matInput
                          type="text"
                          [(ngModel)]="selectedDivisonColor"
                          (blur)="onColorTextBlur($event)"
                          [ngModelOptions]="{ standalone: true }"
                          [disabled]="!divisionVisible"
                          placeholder="#RRGGBB" />
                        </mat-form-field>
                      </div>
                      <div class="division-grid">
                        <!-- Fax (numeric) -->
                        <div class="grid-item">
                          <mat-form-field appearance="outline" class="field-input small-text-field">
                            <mat-label>Fax</mat-label>
                            <input
                              matInput
                              type="text"
                              [(ngModel)]="divisionFax"
                              [ngModelOptions]="{ standalone: true }"
                              [disabled]="!divisionVisible"
                              placeholder="e.g. 6025551234" />
                            </mat-form-field>
                          </div>
                          <!-- Phone (numeric) -->
                          <div class="grid-item">
                            <mat-form-field appearance="outline" class="field-input small-text-field">
                              <mat-label>Phone</mat-label>
                              <input
                                matInput
                                type="text"
                                [(ngModel)]="divisionPhone"
                                [ngModelOptions]="{ standalone: true }"
                                [disabled]="!divisionVisible"
                                placeholder="e.g. 6025559876" />
                              </mat-form-field>
                            </div>
                            <!-- Map URL (textbox) -->
                            <div class="grid-item">
                              <mat-form-field appearance="outline" class="field-input">
                                <mat-label>Map URL</mat-label>
                                <input
                                  matInput
                                  type="text"
                                  [(ngModel)]="divisionMapUrl"
                                  [ngModelOptions]="{ standalone: true }"
                                  [disabled]="!divisionVisible"
                                  placeholder="https://maps.example.com/..." />
                                </mat-form-field>
                              </div>
                              <!-- Dept Address (textarea) — span both columns -->
                              <div class="grid-item">
                                <mat-form-field appearance="outline" class="field-input">
                                  <mat-label>Department Address</mat-label>
                                  <textarea
                                    matInput
                                    rows="3"
                                    [(ngModel)]="divisionDeptAddress"
                                    [ngModelOptions]="{ standalone: true }"
                                    [disabled]="!divisionVisible"
                                  placeholder="Street, City, State ZIP"></textarea>
                                </mat-form-field>
                              </div>
                            </div></fieldset>
                            <fieldset>
                              <legend>Section Data</legend>
                              <!-- ROW 1: Section Header Color -->
                              <div class="colorpicker-row">
                                <mat-checkbox
                                  class="row-checkbox"
                                  [(ngModel)]="sectionVisible"
                                  [ngModelOptions]="{ standalone: true }"
                                  >
                                  Visible
                                </mat-checkbox>
                                Section Header Color :
                                <input
                                  id="sectioncolorInput"
                                  type="color"
                                  class="color-input"
                                  [(ngModel)]="sectionData.sectionColor"
                                  [ngModelOptions]="{ standalone: true }"
                                  (input)="onSectionColorChanged($event)"
                                  [disabled]="!sectionVisible"
                                  aria-label="Pick section color"
                                  />
                                  <span class="hex-display">{{ sectionData.sectionColor }}</span>
                                  <mat-form-field appearance="outline" class="text-field small-text-field">
                                    <mat-label>Select/Enter Color</mat-label>
                                    <input
                                      matInput
                                      type="text"
                                      [(ngModel)]="sectionData.sectionColor"
                                      [ngModelOptions]="{ standalone: true }"
                                      [disabled]="!sectionVisible"
                                      placeholder="#RRGGBB"
                                      />
                                    </mat-form-field>
                                  </div>
                                  <!-- ROW 2: Employee Section Fill Color -->
                                  <div class="colorpicker-row">
                                    <div style="width: 160px;"></div>
                                    Section Fill Color : &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <input
                                      id="sectioncolorInput2"
                                      type="color"
                                      class="color-input"
                                      [(ngModel)]="sectionData.sectionEmployeeColor"
                                      [ngModelOptions]="{ standalone: true }"
                                      (input)="onSectionColorEmployeeChanged($event)"
                                      [disabled]="!sectionVisible"
                                      aria-label="Pick section fill color"
                                      />
                                      <span class="hex-display">{{ sectionData.sectionEmployeeColor }}</span>
                                      <mat-form-field appearance="outline" class="text-field small-text-field">
                                        <mat-label>Select/Enter Color</mat-label>
                                        <input
                                          matInput
                                          type="text"
                                          [(ngModel)]="sectionData.sectionEmployeeColor"
                                          [ngModelOptions]="{ standalone: true }"
                                          [disabled]="!sectionVisible"
                                          (input)="onSectionColorEmployeeChanged($event)"
                                          placeholder="#RRGGBB"
                                          />
                                        </mat-form-field>
                                        <span class="hex-display">{{ sectionData.sectionEmployeeColor }}</span>
                                        <br>
                                          Section Note:
                                          <div class="grid-item">
                                            <mat-form-field appearance="outline" class="field-input">
                                              <mat-label>Section Note:</mat-label>
                                              <textarea
                                                matInput
                                                rows="2"
                                                [(ngModel)]="sectionData.sectionNote"
                                                [ngModelOptions]="{ standalone: true }"
                                              placeholder="(F:602-273-2186)"></textarea>
                                            </mat-form-field>
                                          </div>
                                        </div>
                                      </fieldset>
                                    </mat-tab>
                                    <mat-tab label="Employee Data">
                                      <div class="tab-panel">
                                        <div class="white-box">
                                          <!-- section-employee-grid.component.html -->
                                          <div class="emp-grid-scroll">
                                            <table mat-table [dataSource]="sectionEmployees" class="emp-grid mat-elevation-z1">
                                              <!-- Name -->
                                              <ng-container matColumnDef="name" sticky>
                                                <th mat-header-cell *matHeaderCellDef> Name </th>
                                                <td mat-cell *matCellDef="let emp" class="emp-grid__cell">
                                                  {{ emp.firstName }} {{ emp.lastName }}
                                                </td>
                                              </ng-container>
                                              <!-- Contractor -->
                                              <ng-container matColumnDef="contractor">
                                                <th mat-header-cell *matHeaderCellDef> Contractor </th>
                                                <td mat-cell *matCellDef="let emp" class="emp-grid__cell">
                                                  <mat-checkbox
                                                    [checked]="emp.userStatusId === 2"
                                                    (change)="onStatusToggle(emp, $event.checked)"
                                                    aria-label="Active status"
                                                    class="emp-grid__checkbox">
                                                  </mat-checkbox>
                                                </td>
                                              </ng-container>
                                              <!-- Bold -->
                                              <ng-container matColumnDef="bold">
                                                <th mat-header-cell *matHeaderCellDef> Bold </th>
                                                <td mat-cell *matCellDef="let emp" class="emp-grid__cell">
                                                  <mat-checkbox
                                                    [checked]="emp.boldSelected"
                                                    (change)="onBoldToggle(emp, $event.checked)"
                                                    aria-label="Bold toggle"
                                                    class="emp-grid__checkbox">
                                                  </mat-checkbox>
                                                </td>
                                              </ng-container>
                                              <!-- Order -->
                                              <ng-container matColumnDef="order">
                                                <th mat-header-cell *matHeaderCellDef> Order </th>
                                                <td mat-cell *matCellDef="let emp" class="emp-grid__cell">
                                                  <mat-form-field appearance="outline" class="emp-grid__form-field emp-grid__order-field">
                                                    <mat-label>Order</mat-label>
                                                    <input
                                                      matInput
                                                      type="number"
                                                      [(ngModel)]="emp.order"
                                                      [ngModelOptions]="{ standalone: true }"
                                                      min="0" />
                                                    </mat-form-field>
                                                  </td>
                                                </ng-container>
                                                <!-- Color -->
                                                <ng-container matColumnDef="color">
                                                  <th mat-header-cell *matHeaderCellDef> Color </th>
                                                  <td mat-cell *matCellDef="let emp" class="emp-grid__cell emp-grid__color-cell">
                                                    <input
                                                      type="color"
                                                      [value]="emp.employeeColor || '#000000'"
                                                      (input)="onColorChange(emp, $event)"
                                                      aria-label="Employee color"
                                                      class="emp-grid__color-input" />
                                                      <mat-form-field appearance="outline" class="emp-grid__form-field emp-grid__hex-field">
                                                        <mat-label>Hex</mat-label>
                                                        <input
                                                          matInput
                                                          type="text"
                                                          [(ngModel)]="emp.employeeColor"
                                                          [ngModelOptions]="{ standalone: true }"
                                                          placeholder="#RRGGBB" />
                                                        </mat-form-field>
                                                      </td>
                                                    </ng-container>
                                                    <!-- Visible -->
                                                    <ng-container matColumnDef="visible">
                                                      <th mat-header-cell *matHeaderCellDef> Visible </th>
                                                      <td mat-cell *matCellDef="let emp" class="emp-grid__cell">
                                                        <mat-checkbox
                                                          [checked]="emp.visible"
                                                          (change)="onVisibleToggle(emp, $event.checked)"
                                                          aria-label="Visible"
                                                          class="emp-grid__checkbox">
                                                        </mat-checkbox>
                                                      </td>
                                                    </ng-container>
                                                    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true" class="emp-grid__header-row"></tr>
                                                    <tr mat-row *matRowDef="let row; columns: displayedColumns" class="emp-grid__row"></tr>
                                                  </table>
                                                </div>
                                              </div>
                                            </div>
                                          </mat-tab>
                                        </mat-tab-group>
                                      </div>
                                    }
                                  </fieldset>
                                </div>

                              </mat-tab>
                              <mat-tab label="Phone List Others Data">
                                <div class="prd-shell">

                                  <!-- ── FORM CARD ── -->
                                  <section class="prd-card">
                                    <header class="prd-card__head">
                                      <div class="prd-card__icon">
                                        {{ editingId !== null ? '✏️' : '➕' }}
                                      </div>

                                      <div class="prd-card__content">
                                        <h2 class="prd-card__title">
                                          {{ editingId !== null ? 'Edit Record' : 'New Entry' }}
                                          <label class="prd-card__sub">
                                            {{ editingId !== null ? 'Update the office details below' : 'Add a new office to the directory' }}
                                          </label>
                                        </h2>

                                        @if (successMsg) {
                                          <div class="prd-alert prd-alert--success">
                                            <span>✓</span> {{ successMsg }}
                                          </div>
                                        }
                                        @if (errorMsg) {
                                          <div class="prd-alert prd-alert--error">
                                            <span>!</span> {{ errorMsg }}
                                          </div>
                                        }

                                        <div class="prd-card__actions">
                                          <button id="btnSave"  (click) ="onSubmit()" class="prd-btn prd-btn--primary" [disabled]="submitting">
                                            {{ submitting ? 'Saving…' : (editingId !== null ? 'Update' : 'Save') }}
                                          </button>
                                          @if (editingId !== null) {
                                            <button id="btnReset" type="button" class="prd-btn prd-btn--ghost"
                                            (click)="resetForm()">Cancel</button>
                                          }
                                        </div>
                                      </div>
                                    </header>



                                    <form [formGroup]="form" novalidate>
                                      <div class="prd-grid">

                                        <div class="prd-field prd-field--full">
                                          <label class="prd-label">Office Name <span class="req">*</span></label>
                                          <input formControlName="officeName" class="prd-input"
                                            placeholder="e.g. City Fire Department" />
                                            @if (f['officeName'].touched && f['officeName'].errors?.['required']) {
                                              <span class="prd-err"
                                                >
                                                Office Name is required.
                                              </span>
                                            }
                                          </div>

                                          <div class="prd-field prd-field--full">
                                            <label class="prd-label">Office Type <span class="req">*</span></label>
                                            <div class="prd-toggle-group">
                                              @for (ot of officeTypes; track ot) {
                                                <label class="prd-toggle"
                                                  [class.prd-toggle--emergency]="ot === 'Emergency'"
                                                  [class.prd-toggle--nonemergency]="ot === 'Non-Emergency'"
                                                  [class.prd-toggle--none]="ot === 'None'"
                                                  [class.prd-toggle--active]="f['officeType'].value === ot">
                                                  <input type="radio" formControlName="officeType" [value]="ot" hidden />
                                                  @if (ot === 'Emergency') {
                                                    <span class="prd-toggle__icon">🚨</span>
                                                  }
                                                  @if (ot === 'Non-Emergency') {
                                                    <span class="prd-toggle__icon">🏢</span>
                                                  }
                                                  @if (ot === 'None') {
                                                    <span class="prd-toggle__icon">📋</span>
                                                  }
                                                  {{ ot }}
                                                </label>
                                              }
                                            </div>
                                          </div>

                                          <div class="prd-field prd-field--full">
                                            <label class="prd-label">Phone Number <span class="req">*</span></label>
                                            <input formControlName="phoneNo" class="prd-input"
                                              placeholder="e.g. (602) 262-6151" />
                                              @if (f['phoneNo'].touched && f['phoneNo'].errors?.['required']) {
                                                <span class="prd-err"
                                                  >
                                                  Phone No is required.
                                                </span>
                                              }
                                            </div>

                                            <div class="prd-field">
                                              <label class="prd-label">Fill Color</label>
                                              <div class="prd-color-row">
                                                <input type="color" formControlName="fillColor" class="prd-color-picker" />
                                                <input formControlName="fillColor" class="prd-input prd-input--hex" maxlength="9" />
                                              </div>
                                              <div class="prd-color-preview" [style.background]="f['fillColor'].value"></div>
                                            </div>

                                            <div class="prd-field">
                                              <label class="prd-label">Border Color</label>
                                              <div class="prd-color-row">
                                                <input type="color" formControlName="borderColor" class="prd-color-picker" />
                                                <input formControlName="borderColor" class="prd-input prd-input--hex" maxlength="9" />
                                              </div>
                                              <div class="prd-color-preview" [style.background]="f['borderColor'].value"></div>
                                            </div>

                                          </div>


                                        </form>
                                      </section>
                                      <!-- ── DIRECTORY ── -->
                                      <section class="prd-view">
                                        <div class="prd-view-scroll">
                                          @if (sortedRecords.length) {
                                            <div class="prd-masonry">
                                              @for (r of sortedRecords; track r) {
                                                <article
                                                  class="prd-office-card"
                                                  [class.prd-office-card--emergency]="r.officeType === 'Emergency'"
                                                  [class.prd-office-card--nonemergency]="r.officeType === 'Non-Emergency'"
                                                  [class.prd-office-card--none]="r.officeType === 'None'"
                                                  [style.background]="r.fillColor"
                                                  [style.border-color]="r.borderColor">
                                                  <div class="prd-office-card__bar"></div>
                                                  <div class="prd-office-card__body">
                                                    <div class="prd-office-card__top">
                                                      <h3 class="prd-office-card__name">{{ r.officeName }}</h3>
                                                      <div class="prd-office-card__type-pill"
                                                        [class.pill--emergency]="r.officeType === 'Emergency'"
                                                        [class.pill--nonemergency]="r.officeType === 'Non-Emergency'"
                                                        [class.pill--none]="r.officeType === 'None'">
                                                        @if (r.officeType === 'Emergency') {
                                                          <span>🚨</span>
                                                        }
                                                        @if (r.officeType === 'Non-Emergency') {
                                                          <span>🏢</span>
                                                        }
                                                        @if (r.officeType === 'None') {
                                                          <span>📋</span>
                                                        }
                                                        {{ r.officeType }}
                                                      </div>
                                                    </div>
                                                    <a class="prd-office-card__phone" [href]="'tel:' + r.phoneNo">
                                                      <span class="prd-office-card__phone-icon">📞</span>
                                                      {{ r.phoneNo }}
                                                    </a>
                                                    <div class="prd-office-card__actions">
                                                      <button class="prd-btn-sm prd-btn-sm--edit" (click)="editRecord(r)">
                                                        ✏️ Edit
                                                      </button>
                                                      <button class="prd-btn-sm prd-btn-sm--del" (click)="deleteRecord(r.id)">
                                                        🗑 Delete
                                                      </button>
                                                    </div>
                                                  </div>
                                                </article>
                                              }
                                            </div>
                                          } @else {
                                            <div class="prd-empty">
                                              <div class="prd-empty__icon">📭</div>
                                              <p class="prd-empty__title">No offices yet</p>
                                              <p class="prd-empty__sub">Use the form above to add your first entry.</p>
                                            </div>
                                          }


                                        </div>
                                      </section>
                                      <div style="height: 100px;"></div>
                                    </div>

                                  </mat-tab>
                                  <mat-tab label="Phone Desk Office">
                                    <div class="om-wrapper">

                                      <div class="om-toolbar">
                                        <h2 class="om-title">Office Directory</h2>
                                        <label style="color: red;"> Note: #47c026 is hard color code for Fill Color to display office in first column, #8a80db is hard color code for Fill Color to display office in 2nd column</label>
                                        <br/>
                                        <button class="btn btn-primary" (click)="openAddOffice()">+ Add Office</button>
                                      </div>
                                      <div class="prd-view-scroll-ph">
                                        @if (showOfficeForm) {
                                          <div class="om-form-card">
                                            <h3>{{ editingOfficeId == null ? 'Add Office' : 'Edit Office' }}</h3>
                                            <div class="form-row">
                                              <label>Office Name</label>
                                              <input type="text" [(ngModel)]="officeForm.officeName" maxlength="150"
                                                placeholder="Enter office name">
                                              </div>
                                              <div class="form-row form-row--colors">
                                                <div class="color-field">
                                                  <label>Fill Color</label>
                                                  <input type="color" [(ngModel)]="officeForm.fillColor">
                                                </div>
                                                <div class="color-field">
                                                  <label>Border Color</label>
                                                  <input type="color" [(ngModel)]="officeForm.borderColor">
                                                </div>
                                                <div class="color-field">
                                                  <label>Font Color</label>
                                                  <input type="color" [(ngModel)]="officeForm.fontColor">
                                                </div>
                                              </div>
                                              <!-- live preview -->
                                              <div class="form-row">
                                                <label>Preview</label>
                                                <div class="office-preview"
                                                  [style.background]="officeForm.fillColor"
                                                  [style.border-color]="officeForm.borderColor"
                                                  [style.color]="officeForm.fontColor">
                                                  {{ officeForm.officeName || 'Office Name' }}
                                                </div>
                                              </div>
                                              <div class="form-actions">
                                                <button class="btn btn-primary" (click)="saveOffice()">Save</button>
                                                <button class="btn btn-ghost" (click)="cancelOfficeForm()">Cancel</button>
                                              </div>
                                            </div>
                                          }

                                          <!-- ===== OFFICE GRID ===== -->
                                          @if (loading) {
                                            <div class="om-loading">Loading…</div>
                                          }

                                          @if (!loading) {
                                            <table class="om-grid">
                                              <thead>
                                                <tr>
                                                  <th style="width:90px;">Preview</th>
                                                  <th>Office Name</th>
                                                  <th style="width:110px;">Fill</th>
                                                  <th style="width:110px;">Border</th>
                                                  <th style="width:110px;">Font</th>
                                                  <th style="width:260px;">Actions</th>
                                                </tr>
                                              </thead>
                                              <tbody>
                                                @for (o of offices; track trackByOffice($index, o)) {
                                                  <tr [class.row-selected]="selectedOfficeId === o.officeId">
                                                    <td>
                                                      <span class="swatch-chip"
                                                        [style.background]="o.fillColor"
                                                        [style.border-color]="o.borderColor"
                                                      [style.color]="o.fontColor">Aa</span>
                                                    </td>
                                                    <td>{{ o.officeName }}</td>
                                                    <td><span class="swatch" [style.background]="o.fillColor"></span>{{ o.fillColor }}</td>
                                                    <td><span class="swatch" [style.background]="o.borderColor"></span>{{ o.borderColor }}</td>
                                                    <td><span class="swatch" [style.background]="o.fontColor"></span>{{ o.fontColor }}</td>
                                                    <td class="actions-cell">
                                                      <button class="btn btn-sm" (click)="openEditOffice(o)">Edit</button>
                                                      <button class="btn btn-sm btn-danger" (click)="deleteOffice(o)">Delete</button>
                                                      <button class="btn btn-sm btn-accent" (click)="selectOffice(o)">
                                                        {{ selectedOfficeId === o.officeId ? 'Hide Phone Desks' : 'Show Phone Desks' }}
                                                      </button>
                                                    </td>
                                                  </tr>
                                                  @if (selectedOfficeId === o.officeId) {
                                                    <tr class="subgrid-row">
                                                      <td colspan="6">
                                                        <div class="subgrid">
                                                          <div class="subgrid-header">
                                                            <h4>Phone Desks — {{ o.officeName }}</h4>
                                                            <button class="btn btn-sm btn-primary" (click)="openAddDesk()">
                                                              + Add Phone Desk
                                                            </button>
                                                          </div>
                                                          <!-- Phone desk entry form -->
                                                          @if (showDeskForm) {
                                                            <div class="desk-form">
                                                              <div class="form-row form-row--inline">
                                                                <div class="inline-field">
                                                                  <label>Desk Location</label>
                                                                  <input type="text" [(ngModel)]="deskForm.deskLocation"
                                                                    maxlength="150" placeholder="e.g. Front Reception">
                                                                  </div>
                                                                  <div class="inline-field">
                                                                    <label>Phone No</label>
                                                                    <input type="text" [(ngModel)]="deskForm.phoneNo"
                                                                      maxlength="50" placeholder="e.g. 555-0100">
                                                                    </div>
                                                                    <div class="inline-actions">
                                                                      <button class="btn btn-sm btn-primary" (click)="saveDesk()">Save</button>
                                                                      <button class="btn btn-sm btn-ghost" (click)="cancelDeskForm()">Cancel</button>
                                                                    </div>
                                                                  </div>
                                                                </div>
                                                              }
                                                              @if (loadingDesks) {
                                                                <div class="om-loading">Loading phone desks…</div>
                                                              }
                                                              @if (!loadingDesks) {
                                                                <table class="subgrid-table">
                                                                  <thead>
                                                                    <tr>
                                                                      <th>Desk Location</th>
                                                                      <th style="width:160px;">Phone No</th>
                                                                      <th style="width:160px;">Actions</th>
                                                                    </tr>
                                                                  </thead>
                                                                  <tbody>
                                                                    @for (d of phoneDesks; track trackByDesk($index, d)) {
                                                                      <tr>
                                                                        <td>{{ d.deskLocation }}</td>
                                                                        <td>{{ d.phoneNo }}</td>
                                                                        <td class="actions-cell">
                                                                          <button class="btn btn-sm" (click)="openEditDesk(d)">Edit</button>
                                                                          <button class="btn btn-sm btn-danger" (click)="deleteDesk(d)">Delete</button>
                                                                        </td>
                                                                      </tr>
                                                                    }
                                                                    @if (!phoneDesks.length) {
                                                                      <tr>
                                                                        <td colspan="3" class="empty-cell">No phone desks added yet.</td>
                                                                      </tr>
                                                                    }
                                                                  </tbody>
                                                                </table>
                                                              }
                                                            </div>
                                                          </td>
                                                        </tr>
                                                      }
                                                    }
                                                    @if (!offices.length) {
                                                      <tr>
                                                        <td colspan="6" class="empty-cell">No offices available.</td>
                                                      </tr>
                                                    }
                                                  </tbody>
                                                </table>
                                              }
                                            </div>

                                          </div>

                                        </mat-tab>

                                      </mat-tab-group>